import { defineStore } from 'pinia'
import { ref, reactive } from 'vue'
import axios from '@/libs/axios'

export const useAppStore = defineStore('rysqer-app-store', () => {
	let apps = reactive({})

	let active = reactive({
		app: null,
		view: null,
		scene: null,
		filters: [],
	})

	const createApp = (id, theViews) => {
		let views = reactive({})

		for (let i = 0; i < theViews.length; i++) {
			views[theViews[i].id] = createView(theViews[i])
		}

		const config = reactive({})
		const appLevelConfigs = reactive({})

		apps[id] = {
			id: id,
			options: {},
			views: views,
			showTabs: true,
			config: config,
			appLevelConfigs: appLevelConfigs,

			activate: () => {
				active.app = apps[id]
			},

			async loadConfig() {
				try {
					const response = await axios.get(`/apps/config?app=${id}`)
					Object.assign(config, response.data)
				} catch (error) {
					console.warn(`Failed to load config for app ${id}`, error)
				}
			},

			async getAppLevelConfig(appLevel) {
				if (appLevelConfigs[appLevel]) {
					return appLevelConfigs[appLevel]
				}

				try {
					const response = await axios.get(`/apps/app-levels/config?app=${id}&appLevel=${appLevel}`)
					const loadedConfig = response.data
					appLevelConfigs[appLevel] = loadedConfig
					return loadedConfig
				} catch (error) {
					console.warn(`Failed to load appLevel config for ${id}/${appLevel}`, error)
					return null
				}
			},
		}

		apps[id].loadConfig()

		return apps[id]
	}

	const createView = (view) => {
		let theView = {
			id: view.id,
			label: view.label,
			indicator: view.indicator,
			component: view.component,
			route: view.route,
			condition: view.condition,
			options: view.options || {},
			class: view.class,
			activate: null,
			scenes: null,
			createScenes: null,
		}

		let scenes = reactive({})

		let createScenes = (theScenes) => {
			for (let i = 0; i < theScenes.length; i++) {
				scenes[theScenes[i].id] = createScene(theScenes[i], theView)
			}
		}

		let activate = (scene = null) => {
			active.view = active.app.views[view.id]
			active.scene = scene
		}

		theView.scenes = scenes
		theView.createScenes = createScenes
		theView.activate = activate

		return reactive(theView)
	}

	const createScene = (scene, view) => {
		let theScene = {
			id: scene.id,
			label: scene.label,
			component: scene.component,
			class: scene.class,
			options: scene.options || {},
			view: view,
			label: null,
			sections: null,
			sectionsArray: ref([]),
			createSections: null,
		}

		let sections = reactive({})
		let sectionsArray = ref([])

		let createSections = (theSections) => {
			sectionsArray.value.splice(0)

			for (let i = 0; i < theSections.length; i++) {
				const theSection = createSection(theSections[i])
				sections[theSections[i].id] = theSection
				sectionsArray.value.push(theSection)
			}
		}

		theScene.createSections = createSections
		theScene.sections = sections
		theScene.sectionsArray = sectionsArray

		return reactive(theScene)
	}

	const createSection = (section) => {
		let theSection = {
			id: section.id,
			label: section.label,
			component: section.component,
			class: section.class,
			options: section.options || {},
			visible: section.visible == null ? true : section.visible,
			condition: section.condition,

			show() {
				this.visible = true
			},

			hide() {
				this.visible = false
			},

			toggle() {
				this.visible = !this.visible
			},
		}

		return reactive(theSection)
	}

	return {
		apps,
		active,
		createApp,
		createView,
		createScene,
	}
})
